export default "__VITE_ASSET__Duah1i3W__"